import { Box, Tab, Tabs, Typography, useTheme } from '@mui/material'
import { FC, SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch } from '../../../../store'
import { TechnologyActions } from '../../../../store/technology'
import { Matches, Pipeline, ProjectOverview, SubmittedGrants } from './Tabs'
import { PrivateFoundations } from './Tabs/PrivateFoundations'

const TAB_HEADER = ['Overview', 'Pipeline', 'Matches', 'Private Foundations' ,'Submitted']

export const Project: FC = () => {
  const theme = useTheme()

  const { projectId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const [selectedTab, setSelectedTab] = useState('Overview')

  const fetchProjectDetails = useCallback(() => {
    if (projectId) {
      dispatch(
        TechnologyActions.fetchTechnologyAsync({
          id: projectId,
          options: {
            params: {
              $includes: 'users',
            },
          },
        }),
      )
    }
  }, [projectId, dispatch])

  useEffect(() => {
    fetchProjectDetails()
  }, [fetchProjectDetails])

  const handleTabChange = (event: SyntheticEvent, newTab: string) => {
    setSelectedTab(newTab)
  }

  return (
    <Box>
      <Tabs
        value={selectedTab}
        textColor={'primary'}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        onChange={handleTabChange}
        sx={{ borderBottom: `1px solid ${theme.palette.grey[300]}` }}
      >
        {TAB_HEADER.map((header) => (
          <Tab
            key={header}
            value={header}
            label={
              <Typography
                textAlign="left"
                fontSize="0.9rem"
                textTransform="none"
                fontWeight={theme.typography.fontWeightMedium}
              >
                {header}
              </Typography>
            }
          />
        ))}
      </Tabs>

      <Box my={3}>
        {selectedTab === 'Overview' && <ProjectOverview />}
        {selectedTab === 'Matches' && <Matches />}
        {selectedTab === 'Submitted' && <SubmittedGrants />}
        {selectedTab === 'Pipeline' && <Pipeline />}
        {selectedTab === 'Private Foundations' && <PrivateFoundations />}
      </Box>
    </Box>
  )
}
